module.exports = __webpack_public_path__ + "static/media/order_notify.d5e6cecc.png";